<template>
    <a-modal
        centered
        title="添加到快速访问"
        :visible="visible"
        @ok="on_ok"
        @cancel="on_cancel"
        :width="360"
        :confirm-loading="submitting"
        :after-close="after_close"
        :ok-button-props="{ props: { disabled: !form.name } }"
    >
        <p>将当前链接添加到快速访问，以便在仪表盘以及菜单栏快速进入。</p>
        <a-form-model :model="form" :rules="rules" ref="shortcut-create">
            <a-form-model-item label="访问名称" prop="name">
                <a-input v-model="form.name" />
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    export default {
        data() {
            return {
                visible: false,
                callback: null,
                submitting: false,
                form: {
                    url: null,
                    name: null,
                    module: null,
                },
                rules: {
                    name: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "请输入名称",
                        },
                    ],
                },
            };
        },
        created() {
            this.$event_bus.$on("visible_shortcut", (record, callback) => {
                this.visible = true;
                let param = {
                    url: this.$route.fullPath,
                    name: this.$route.meta.title,
                    module: this.$route.meta.as,
                };

                this.form = JSON.parse(JSON.stringify({ ...record, ...param }));

                // this.record = record;
                // this.status_selected = record.status || {};

                if (callback) {
                    this.callback = callback;
                }
            });
        },
        methods: {
            on_ok() {
                this.$refs["shortcut-create"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        this.$http
                            .post("/auth/module/shortcut", this.form)
                            .then((res) => {
                                if (res.success) {
                                    this.$message.success(res.message);
                                    this.on_cancel();
                                } else {
                                    this.$error({
                                        title: "失败",
                                        content: res.message,
                                    });
                                }
                            })
                            .catch(() => {})
                            .then(() => {
                                this.submitting = false;
                            });
                    }
                });
            },
            after_close() {
                this.$refs["shortcut-create"].resetFields();
            },
            on_cancel() {
                this.visible = false;
            },
        },
    };
</script>
